import { observer } from "mobx-react-lite";
import i from "../../../translations/i";
import { Titles } from "../../../layouts/Titles";
import controller from './discount.controller'
import {
  Button,
  Col,
  Divider,
  Input,
  InputNumber,
  Modal,
  Form,
  Row,
  Select,
  Space,
  Switch,
  TimePicker,
  Typography
} from "antd";
import React, { useEffect } from "react";
import { returnParseProjectElement } from "../../../helpers/project.controller";
import { useParams } from "react-router-dom";
import { ParamTypes } from "../../../helpers/types.interfaces";
import { SwitchBlock } from "../../../components/SwitchBlock"
import { CustomProductListsLayout } from "../../catalog/custom_product_lists/CustomProductListsLayout";
import { __cpl } from "../../catalog/custom_product_lists/__cpl";
import dayjs from "dayjs";
import moment from "moment";
import { DeleteOutlined } from "@ant-design/icons";
import { storeLocal } from "../../../helpers/stores";
import { ErrorByPricingPlan } from "../../../components/ErrorByPricingPlan";
import __select from "../../../helpers/select_entity/__select.controller";
import { SelectProducts } from "../../../helpers/select_entity/SelectEntity";
import { RestrictedSelect } from "../../../components/access";

export const Discount = observer(() => {

  const { id }: any = useParams<ParamTypes>()

  useEffect(() => {
    controller.getOne(id)
  }, [id])

  const buttons = [
    { title: i.t('def:actions.backList'), href: `/settings/discount`, type: 'dashed' },
    { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
  ]

  return(
    <>
      <form onSubmit={(e) => controller.save(e)}>
        <Titles
          title={i.t('def:Discount')}
          buttons={buttons}
        />

        <Row gutter={[20, 20]}>
          <Col span={24}>
            <SwitchBlock newDesign={true} array={[
              { label: i.t('settings:cities.form.enabled'), click: (e: any) => controller.item.enabled = e, value: controller.item.enabled },
              { label: i.t('def:apply_old_price'), click: (e: any) => controller.item.apply_old_price = e, value: controller.item.apply_old_price, block: 3 },
              { label: i.t('discount:disableAccrual'), click: (e: any) => controller.item.disable_accrual = e, value: controller.item.disable_accrual, block: 3 },
              { label: i.t('discount:prohibitWriteOff'), click: (e: any) => controller.item.prohibit_write_off = e, value: controller.item.prohibit_write_off, block: 3 },
              { label: i.t('discount:birthdayOnly'), click: (e: any) => controller.item.birthday = e, value: controller.item.birthday, block: 3 },
            ]} />
          </Col>
          {controller.item.birthday ? <Col xs={24} md={12}>
            <label>{i.t('discount:birthdayDaysRange')}</label>
            <InputNumber
              value={controller.item.birthday_limit}
              onChange={(e: any) => controller.item.birthday_limit = e}
              style={{ width: '100%' }}
            />
          </Col> : <></>}
          <Col xs={24} md={12}>
            <label>{i.t('settings:cities.form.name')}</label>
            <Input
              name="name"
              placeholder={i.t('settings:cities.form.name')}
              value={controller.item.name}
              onChange={(e) => controller.item.name = e.target.value}
            />
          </Col>
          <Col xs={24} md={12}>
            <label>{i.t('def:description')}</label>
            <Input
              name="description"
              value={controller.item.description}
              onChange={(e) => controller.item.description = e.target.value}
            />
          </Col>
          <Col xs={24} md={12}>
            <label>{i.t('def:id_crm')}</label>
            <Input
              name="id_crm"
              placeholder={i.t('def:id_crm')}
              value={controller.item.id_crm}
              onChange={(e) => controller.item.id_crm = e.target.value}
            />
          </Col>
          <Col xs={24} md={12}>
            <label>{i.t('discount:minCart')}</label>
            <InputNumber
              value={controller.item.min_cart}
              onChange={(e: any) => controller.item.min_cart = e}
              style={{ width: '100%' }}
            />
          </Col>
          <Col xs={24} md={12}>
            <label>{i.t('def:Discount purpose')}</label>
            <Select
              style={{ width: `100%` }}
              placeholder={i.t('def:Discount purpose')}
              value={controller.item.purpose}
              onChange={(e) => controller.item.purpose = e}
              options={[
                { label: i.t('discount:noLimits'), value: null },
                { label: i.t('discount:purposeCartDelivery'), value: 'cart_delivery' },
                { label: i.t('discount:purposeCartPickup'), value: 'cart_pickup' },
              ]}
            />
          </Col>
          <Col xs={24} md={12}>
            <label>{i.t('discount:warehousesLabel')}</label>
            <RestrictedSelect
              plan={3}
              mode="multiple"
              style={{ width: `100%` }}
              placeholder={i.t('discount:warehousesPlaceholder')}
              value={controller.item.warehouses.map((el: any) => el.warehouse_id)}
              onChange={(e: any) => controller.item.warehouses = e.map((warehouse_id: any) => ({ warehouse_id }))}
              options={controller.data.warehouses.map((el: any) => ({
                value: el.id,
                label: el.name
              }))}
              disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}
            />
          </Col>
          <Col xs={24} md={12}>
            <label>{i.t('discount:platformsLabel')}</label>
            <RestrictedSelect
              plan={3}
              mode="multiple"
              style={{ width: `100%` }}
              placeholder={i.t('discount:platformsPlaceholder')}
              value={controller.item.platforms.map((el: any) => el.platform)}
              onChange={(e: any) => controller.item.platforms = e.map((platform: any) => ({ platform }))}
              options={[
                { label: i.t('discount:platformWeb'), value: 'web' },
                { label: i.t('discount:platformIphone'), value: 'iphone' },
                { label: i.t('discount:platformAndroid'), value: 'android' },
              ]}
              disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}
            />
          </Col>
          <Col xs={24} md={12}>
            <label>{i.t('discount:selectType')}</label>
            <Select
              style={{ width: `100%` }}
              placeholder={i.t('def:Measurement')}
              value={controller.item.measurement}
              onChange={(e) => controller.item.measurement = e}
              options={[
                { label: i.t('discount:measurementPercent'), value: 0 },
                { label: i.t('discount:measurementFixed'), value: 1 },
                { label: i.t('discount:measurementGift'), value: 2, disabled: storeLocal.get('pricing_plan') < 2 },
                { label: i.t('discount:measurementBuyXPlus1'), value: 3, disabled: storeLocal.get('pricing_plan') < 3 },
                { label: i.t('discount:measurementBuyXGetY'), value: 4, disabled: storeLocal.get('pricing_plan') < 3 },
              ]}
            />
          </Col>
          {controller.item.measurement < 2 ? <Col xs={24} md={12}>
            <label>{i.t('def:Discount amount')}</label>
            <InputNumber
              name="amount"
              style={{ width: `100%` }}
              placeholder={i.t('def:Discount amount')}
              value={controller.item.amount}
              onChange={(e) => controller.item.amount = e}
            />
          </Col> : <></>}

          {(controller.item.measurement === 3 || controller.item.measurement === 4)
            ? <>
              <Col xs={24} md={24}>
                <SwitchBlock newDesign={true} array={[
                  { label: i.t('discount:cyclicalLabel'), click: (e: any) => controller.item.cyclical = e, value: controller.item.cyclical },
                ]} />
              </Col>
              {controller.item.measurement === 3
                ? <>
                    <Col xs={24} md={8}>
                      <label>{i.t('discount:giftItemsCount')}</label>
                      <InputNumber
                        name="how_many_items_gift"
                        style={{ width: `100%` }}
                        value={controller.item.how_many_items_gift}
                        onChange={(e) => controller.item.how_many_items_gift = e}
                      />
                    </Col>
                    <Col xs={24} md={8}>
                      <label>{i.t('discount:giftItemPrice')}</label>
                      <InputNumber
                        name="price"
                        style={{ width: `100%` }}
                        value={controller.item.price}
                        onChange={(e) => controller.item.price = e}
                      />
                    </Col>
                  </>
                : <></>
              }
                    <Col xs={24} md={8}>
                      <label>{i.t('discount:cartItemsRequiredCount')}</label>
                      <InputNumber
                        name="how_many_items_cart"
                        style={{ width: `100%` }}
                        value={controller.item.how_many_items_cart}
                        onChange={(e) => controller.item.how_many_items_cart = e}
                      />
                    </Col>
                  </>
                : <></>}

          <Divider />
          {(controller.item.measurement < 2 || controller.item.measurement === 2 || controller.item.measurement === 3 || controller.item.measurement === 4)
            ? <>
              <Col span={12}>
                <label>{controller.item.measurement === 2 ? i.t('discount:productsForGiftThreshold') : i.t('discount:productsInDiscount')}</label>

                <ErrorByPricingPlan
                  content={
                    <Button
                      onClick={() => controller.openModal('products_active')}
                      disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}
                    >{i.t('def:setting')}</Button>
                  }
                  plan={3}
                />

                {controller.item.products_active.length > 0 ?
                  <>
                    <br/><br/>
                    <Row gutter={[15, 15]}>
                      <Col span={24}>
                        <label>{i.t('discount:selectedProductLists')}</label>
                      </Col>
                      {controller.item.products_active.map((el: any, index: number) => el.list ? (
                        <Col span={24}>
                          <Space>
                            <a href={`/catalog/lists/${el.list.id}`} target="_blank">{el.list.name}</a>
                            <Button
                              type="dashed"
                              shape="circle"
                              danger
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={() => controller.deleteProductList('products_active', index)}
                            />
                          </Space>
                        </Col>
                      ) : <></>)}
                    </Row>
                  </>
                  : <></>}

              </Col>
              {controller.item.measurement < 2 ? <>
                <Col span={12}>
                  <label>{i.t('discount:productsNotInDiscount')}</label>

                  <ErrorByPricingPlan
                    content={
                      <Button onClick={() => controller.openModal('products_not_active')} disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}>{i.t('def:setting')}</Button>
                    }
                    plan={3}
                  />

                  {controller.item.products_not_active.length > 0 ?
                    <>
                      <br/><br/>
                      <Row gutter={[15, 15]}>
                        <Col span={24}>
                          <label>{i.t('discount:selectedProductLists')}</label>
                        </Col>
                        {controller.item.products_not_active.map((el: any, index: number) => el.list ? (
                          <Col span={24}>
                            <Space>
                              <a href={`/catalog/lists/${el.list.id}`} target="_blank">{el.list.name}</a>
                              <Button
                                type="dashed"
                                shape="circle"
                                danger
                                size="small"
                                icon={<DeleteOutlined />}
                                onClick={() => controller.deleteProductList('products_not_active', index)}
                              />
                            </Space>
                          </Col>
                        ) : <></>)}
                      </Row>
                    </>
                    : <></>}
                </Col>
              </> : <></>}

            </>
            : <></>
          }

          {(controller.item.measurement === 2 || controller.item.measurement === 4) ? <GiftsComponent /> : <></>}


          <Divider />

          <Col span={24}>
            <Typography.Title level={3}>{i.t('discount:activityPeriods')}</Typography.Title>
          </Col>
          <Col span={24}>
            <label>{i.t('discount:selectActivityIntervals')}</label>

            <Row gutter={[20, 20]} justify="space-between" align="bottom">
              <Col span={24}>
                <ErrorByPricingPlan
                  content={
                    <Button onClick={() => controller.addPeriod()} disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}>{i.t('discount:addPeriod')}</Button>
                  }
                  plan={3}
                />
              </Col>
              <Col span={24}>
                <Row gutter={[20, 20]}>
                  {controller.item.periods.map((el: any, index: number) => (
                    <>
                      <Col span={8}>
                        <label>{i.t('discount:periodDateFromLabel')}</label>
                        <Input
                          placeholder={i.t('discount:periodDatePlaceholder')}
                          allowClear
                          onChange={(e) => controller.item.periods[index].date_from = e.target.value}
                          value={el.date_from ?? ''}
                        />
                      </Col>
                      <Col span={8}>
                        <label>{i.t('discount:periodDateToLabel')}</label>
                        <Input
                          placeholder={i.t('discount:periodDatePlaceholder')}
                          allowClear
                          onChange={(e) => controller.item.periods[index].date_to = e.target.value}
                          value={el.date_to ?? ''}
                        />
                      </Col>
                      <Col span={6}>
                        <label>{i.t('discount:periodYearLabel')}</label>
                        <InputNumber
                          onChange={(e) => controller.item.periods[index].year = e}
                          value={el.year ?? null}
                          style={{ width: '100%' }}
                        />
                      </Col>
                      <Col span={2}>
                        <Button
                          type="dashed"
                          shape="circle"
                          danger
                          icon={<DeleteOutlined />}
                          onClick={() => controller.deletePeriod(index)}
                        />
                      </Col>
                      <Divider />
                    </>
                  ))}
                </Row>
              </Col>
              <Col span={24}>
                <ErrorByPricingPlan
                  content={
                    <Button onClick={() => controller.addDay()} disabled={storeLocal.get('pricing_plan') < 3 || storeLocal.get('black_mark')}>{i.t('discount:addSchedule')}</Button>
                  }
                  plan={3}
                />
              </Col>
              {controller.item.schedule.map((el: any, index: number) => {
                return(
                  <>
                    <Col span={8}>
                      <label>{i.t('discount:dayLabel')}</label>
                      <Select
                        options={[
                          { label: i.t('discount:weekdays.monday'), value: 1 },
                          { label: i.t('discount:weekdays.tuesday'), value: 2 },
                          { label: i.t('discount:weekdays.wednesday'), value: 3 },
                          { label: i.t('discount:weekdays.thursday'), value: 4 },
                          { label: i.t('discount:weekdays.friday'), value: 5 },
                          { label: i.t('discount:weekdays.saturday'), value: 6 },
                          { label: i.t('discount:weekdays.sunday'), value: 7 },
                        ]}
                        value={el.day}
                        onChange={(e) => controller.item.schedule[index].day = e}
                        style={{ width: '100%' }}
                      />
                    </Col>
                    <Col span={6}>
                      <label>{i.t('discount:timeStart')}</label>
                      <TimePicker
                        value={el.time_start != null ? dayjs().startOf("day").add(el.time_start, "second") : null}
                        onChange={(time: any) => {
                          const seconds = time.diff(dayjs().startOf("day"), "second")
                          controller.item.schedule[index].time_start = seconds
                        }}
                        format={"HH:mm"}
                        style={{ width: '100%' }}
                      />
                    </Col>
                    <Col span={6}>
                      <label>{i.t('discount:timeEnd')}</label>
                      <TimePicker
                        value={el.time_end != null ? dayjs().startOf("day").add(el.time_end, "second") : null}
                        onChange={(time: any) => {
                          const seconds = time.diff(dayjs().startOf("day"), "second")
                          controller.item.schedule[index].time_end = seconds
                        }}
                        format={"HH:mm"}
                        style={{ width: '100%' }}
                      />
                    </Col>
                    <Col span={4}>
                      <Button
                        type="dashed"
                        shape="circle"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => controller.deleteSchedule(index)}
                      />
                    </Col>
                  </>
                )
              })}
            </Row>
          </Col>
        </Row>
      </form>


      <Modal
        title={i.t('constructor:editBlock')}
        open={controller.modalOpened}
        footer={null}
        onCancel={() => controller.closeModal()}
        width={1000}
        centered={true}
        maskClosable={false}
      >
        <Row gutter={[20, 20]}>
          <Col span={24}>
            <CustomProductListsLayout selectedElements={[]} />
          </Col>
          <Col span={24}>
            <Button
              type="primary"
              shape="round"
              onClick={() => controller.closeModal()}
            >{i.t('def:actions.save')}</Button>
          </Col>
        </Row>
      </Modal>
    </>
  )
})

const GiftsComponent = observer(() => {

  return(
    <>
      <Col span={24}>
        <Typography.Title level={3}>{i.t('discount:giftLevels')}</Typography.Title>
      </Col>
      <Col span={12}>
        <SwitchBlock newDesign={true} array={[
          { label: i.t('discount:mergeGifts'), click: (e: any) => controller.item.gifts_merge = e, value: controller.item.gifts_merge, block: 3 },
        ]} />
      </Col>
      <Col span={12} className="right">
        <Button onClick={() => controller.addLevel()}>{i.t('discount:addLevel')}</Button>
      </Col>
      <Col span={24}>
        <Row gutter={[20, 20]}>
          <Levels />
        </Row>
      </Col>

      <Modal
        title={i.t('discount:selectProductsTitle')}
        open={controller.modalGiftOpened}
        footer={null}
        onCancel={() => controller.closeGiftModal(controller.modalGiftIndex)}
        width={1000}
        centered={true}
        maskClosable={false}
      >
        <SelectProducts
          elementID={__select.select.value_array}
          returnFunction={(e: any) => {
            controller.addProductToLevel(controller.modalGiftIndex, e)
          }}
          visible={false}
        />
      </Modal>



    </>
  )
})

const Levels = observer(() => {


  return (
    <>
      {controller.item.levels.map((level: any, index: number) => (
        <Col span={24} key={`level_${index}`}>
          <Level level={level} index={index} />
        </Col>
      ))}
    </>
  )
})

const Level = observer(({ level, index }: any) => {

  console.log('render Level')

  return(
    <div className="row-block">
      <Typography.Title level={3}>{i.t('discount:levelNumber', { number: index + 1 })}</Typography.Title>
      <Divider dashed />
      <Row gutter={[20, 20]} justify="space-between" align="bottom">
        <Col span={24}>
          <SwitchBlock newDesign={true} array={[
            { label: i.t('discount:giftsToChoose'), click: (e: any) => controller.item.levels[index].is_select = e, value: level.is_select },
          ]} />
        </Col>
        <Col span={8}>
          <label>{i.t('discount:levelTitleLabel')}</label>
          <Input
            value={level.label}
            onChange={(e: any) => controller.item.levels[index].label = e.target.value}
          />
        </Col>
        <Col span={3}>
          <label>{i.t('discount:sorting')}</label>
          <InputNumber
            value={level.sorting}
            onChange={(e: any) => controller.item.levels[index].sorting = e}
            style={{ width: '100%' }}
          />
        </Col>
        <Col span={6}>
          <label>{i.t('discount:minCart')}</label>
          <InputNumber
            value={level.min_cart}
            onChange={(e: any) => controller.item.levels[index].min_cart = e}
            style={{ width: '100%' }}
          />
        </Col>
       <Col span={7}>
         {level.is_select ? (
           <>
             <label>{i.t('discount:giftsToChooseCount')}</label>
             <InputNumber
               value={level.select_count}
               onChange={(e: any) => controller.item.levels[index].select_count = e}
               style={{ width: "100%" }}
             />
           </>
         ) : <></>}
        </Col>
        <Divider dashed />

        <SelectedProducts level={level} index={index} />

        <Divider dashed />
        <Col span={24}>
          <Space>
            <Button type="dashed" onClick={() => controller.openGiftModal(index)} key={`gift_button_${index}`}>{i.t('discount:selectProducts')}</Button>
            <Button type="dashed" danger onClick={() => controller.deleteLevel(index)}>{i.t('discount:deleteLevel')}</Button>
          </Space>
        </Col>
      </Row>
    </div>
  )
})

const SelectedProducts = observer(({ level, index }: any) => {
  return (
    <Col span={24}>
      <label>{i.t('discount:selectedProducts')}</label><br/><br/>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Row gutter={[15, 15]}>
            <Col span={2}><Typography.Text>ID</Typography.Text></Col>
            <Col span={4}><Typography.Text>{i.t('discount:tableImage')}</Typography.Text></Col>
            <Col span={6}><Typography.Text>{i.t('def:name')}</Typography.Text></Col>
            <Col span={4}><Typography.Text>{i.t('discount:tableQuantity')}</Typography.Text></Col>
            <Col span={6}><Typography.Text>{i.t('discount:tablePricePerItem')}</Typography.Text></Col>
            <Col span={2}></Col>
          </Row>
        </Col>

        <ListItems level={level} index={index} />
      </Row>
    </Col>
  )
})

const ListItems = observer(({ level, index }: any) => {

  return level.products.map((product: any, product_index: number) => (
    <ListItem index={index} product_index={product_index} product={product} />
  ))
})


const ListItem = observer(({ index, product_index, product }: any) => {

  return (
    <Col span={24} key={`select_product_${index}_${product_index}`}>
      <Divider dashed />
      <Row justify="space-around" align="middle" gutter={[15, 15]}>
        <Col span={2}>
          <a href={`/shop/catalog/product/${product.product_id}`} target="_blank">{product.product_id}</a>
        </Col>
        <Col span={4}>
          {product.product && product.product.image ? <img src={product.product.image.path} alt="" width="60px" /> : <></>}
        </Col>
        <Col span={6}>
          {product.product ? product.product.name : i.t('discount:productNotExists')}
        </Col>
        <Col span={4}>
          <InputNumber
            style={{  width: '100%' }}
            value={product.count}
            onChange={(e: any) => controller.setItemLevelsIndexProductsCount(index, product_index, e)}
          />
        </Col>
        <Col span={6}>
          <InputNumber
            style={{  width: '100%' }}
            value={product.price}
            onChange={(e: any) => controller.setItemLevelsIndexProductsPrice(index, product_index, e)}
          />
        </Col>
        <Col span={2}>
          <Button
            icon={<DeleteOutlined />}
            shape="circle"
            type="dashed"
            onClick={() => controller.deleteProductFromLevel(index, product_index)}
            danger
          />
        </Col>
      </Row>
    </Col>
  )
})